import React from 'react';
import { Lead } from '../types';
import { Badge } from './ui/Badge';
interface LeadTableProps {
  leads: Lead[];
  selectedLeads?: Set<string>;
  onToggleSelect?: (leadId: string) => void;
  onSelectAll?: (selected: boolean) => void;
  showSelection?: boolean;
}
export function LeadTable({
  leads,
  selectedLeads = new Set(),
  onToggleSelect,
  onSelectAll,
  showSelection = false
}: LeadTableProps) {
  const allSelected = leads.length > 0 && leads.every(l => selectedLeads.has(l.id));
  const someSelected = leads.some(l => selectedLeads.has(l.id)) && !allSelected;
  return <div className="overflow-hidden border border-slate-200 rounded-lg bg-white shadow-sm" data-id="element-95">
      <div className="overflow-x-auto" data-id="element-96">
        <table className="min-w-full divide-y divide-slate-200" data-id="element-97">
          <thead className="bg-slate-50" data-id="element-98">
            <tr data-id="element-99">
              {showSelection && <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider w-10" data-id="element-100">
                  <input type="checkbox" className="rounded border-slate-300 text-[#0D9488] focus:ring-[#0D9488]" checked={allSelected} ref={input => {
                if (input) input.indeterminate = someSelected;
              }} onChange={e => onSelectAll?.(e.target.checked)} data-id="element-101" />
                </th>}
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-102">
                Name
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-103">
                Contact
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-104">
                Source
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-105">
                Date Added
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-106">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200" data-id="element-107">
            {leads.length === 0 ? <tr data-id="element-108">
                <td colSpan={showSelection ? 6 : 5} className="px-6 py-12 text-center text-slate-500" data-id="element-109">
                  No leads found matching your criteria.
                </td>
              </tr> : leads.map(lead => <tr key={lead.id} className="hover:bg-slate-50 transition-colors" data-id="element-110">
                  {showSelection && <td className="px-6 py-4 whitespace-nowrap" data-id="element-111">
                      <input type="checkbox" className="rounded border-slate-300 text-[#0D9488] focus:ring-[#0D9488]" checked={selectedLeads.has(lead.id)} onChange={() => onToggleSelect?.(lead.id)} data-id="element-112" />
                    </td>}
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-113">
                    <div className="text-sm font-medium text-slate-900" data-id="element-114">
                      {lead.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-115">
                    <div className="text-sm text-slate-500" data-id="element-116">{lead.email}</div>
                    <div className="text-xs text-slate-400" data-id="element-117">{lead.phone}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-118">
                    <Badge className="bg-slate-100 text-slate-700" data-id="element-119">
                      {lead.source}
                    </Badge>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500" data-id="element-120">
                    {lead.dateAdded}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-121">
                    {lead.status === 'unassigned' && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-slate-100 text-slate-800" data-id="element-122">
                        Unassigned
                      </span>}
                    {lead.status === 'assigned_team' && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800" data-id="element-123">
                        Team Assigned
                      </span>}
                    {lead.status === 'assigned_user' && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-124">
                        Ready
                      </span>}
                  </td>
                </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}